import { useState, useEffect, useRef } from "react";
import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";

const fotos = [
  {
    thumb: "https://storage.readdy-site.link/project_files/5397651f-fa4a-4daf-a2cb-668ede89c5b0/e3c39e16-ddd6-444f-b8be-66e4efd4425f_WhatsApp-Image-2026-04-14-at-10.34.43-AM-1.jpeg?v=7992d324208e7f7b79ed8aa5cb99b3ed",
    full: "https://storage.readdy-site.link/project_files/5397651f-fa4a-4daf-a2cb-668ede89c5b0/e3c39e16-ddd6-444f-b8be-66e4efd4425f_WhatsApp-Image-2026-04-14-at-10.34.43-AM-1.jpeg?v=7992d324208e7f7b79ed8aa5cb99b3ed",
    span: "col-span-2 row-span-2",
  },
  {
    thumb: "https://storage.readdy-site.link/project_files/5397651f-fa4a-4daf-a2cb-668ede89c5b0/f382b255-eb08-4400-bb1b-c7d85ad7a0b4_WhatsApp-Image-2026-04-14-at-10.34.43-AM.jpeg?v=e4e1ee86a8774b91b8d73cf6d2ac9483",
    full: "https://storage.readdy-site.link/project_files/5397651f-fa4a-4daf-a2cb-668ede89c5b0/f382b255-eb08-4400-bb1b-c7d85ad7a0b4_WhatsApp-Image-2026-04-14-at-10.34.43-AM.jpeg?v=e4e1ee86a8774b91b8d73cf6d2ac9483",
    span: "col-span-1 row-span-1",
  },
  {
    thumb: "https://storage.readdy-site.link/project_files/5397651f-fa4a-4daf-a2cb-668ede89c5b0/7a927b34-d9ed-4f16-adae-d5d1724abfd0_WhatsApp-Image-2026-04-14-at-10.34.42-AM-7.jpeg?v=95ad86fbd62982720e7b3514d622672e",
    full: "https://storage.readdy-site.link/project_files/5397651f-fa4a-4daf-a2cb-668ede89c5b0/7a927b34-d9ed-4f16-adae-d5d1724abfd0_WhatsApp-Image-2026-04-14-at-10.34.42-AM-7.jpeg?v=95ad86fbd62982720e7b3514d622672e",
    span: "col-span-1 row-span-1",
  },
  {
    thumb: "https://storage.readdy-site.link/project_files/5397651f-fa4a-4daf-a2cb-668ede89c5b0/725694a8-d62c-4a64-a9c2-7ee3f487a705_WhatsApp-Image-2026-04-14-at-10.34.42-AM-6.jpeg?v=4e8914440fa99f3749f18550cbda8748",
    full: "https://storage.readdy-site.link/project_files/5397651f-fa4a-4daf-a2cb-668ede89c5b0/725694a8-d62c-4a64-a9c2-7ee3f487a705_WhatsApp-Image-2026-04-14-at-10.34.42-AM-6.jpeg?v=4e8914440fa99f3749f18550cbda8748",
    span: "col-span-1 row-span-2",
  },
  {
    thumb: "https://storage.readdy-site.link/project_files/5397651f-fa4a-4daf-a2cb-668ede89c5b0/42fd5c15-24ac-4646-8344-739958f1d179_WhatsApp-Image-2026-04-14-at-10.34.42-AM-5.jpeg?v=600381cad674978266e93ac33a53422c",
    full: "https://storage.readdy-site.link/project_files/5397651f-fa4a-4daf-a2cb-668ede89c5b0/42fd5c15-24ac-4646-8344-739958f1d179_WhatsApp-Image-2026-04-14-at-10.34.42-AM-5.jpeg?v=600381cad674978266e93ac33a53422c",
    span: "col-span-2 row-span-1",
  },
  {
    thumb: "https://storage.readdy-site.link/project_files/5397651f-fa4a-4daf-a2cb-668ede89c5b0/197edc30-d0dc-48cf-98bf-163261f95fb7_WhatsApp-Image-2026-04-14-at-10.34.42-AM-4.jpeg?v=2cc1be2e15ae918310d2843b0cd69fb7",
    full: "https://storage.readdy-site.link/project_files/5397651f-fa4a-4daf-a2cb-668ede89c5b0/197edc30-d0dc-48cf-98bf-163261f95fb7_WhatsApp-Image-2026-04-14-at-10.34.42-AM-4.jpeg?v=2cc1be2e15ae918310d2843b0cd69fb7",
    span: "col-span-1 row-span-1",
  },
  {
    thumb: "https://storage.readdy-site.link/project_files/5397651f-fa4a-4daf-a2cb-668ede89c5b0/d6c26c45-71c4-432b-8124-99866f4d87af_WhatsApp-Image-2026-04-14-at-10.34.42-AM-3.jpeg?v=b331a29c3e8bb81a137203874c3434ed",
    full: "https://storage.readdy-site.link/project_files/5397651f-fa4a-4daf-a2cb-668ede89c5b0/d6c26c45-71c4-432b-8124-99866f4d87af_WhatsApp-Image-2026-04-14-at-10.34.42-AM-3.jpeg?v=b331a29c3e8bb81a137203874c3434ed",
    span: "col-span-1 row-span-1",
  },
  {
    thumb: "https://storage.readdy-site.link/project_files/5397651f-fa4a-4daf-a2cb-668ede89c5b0/b9bc670e-839b-4b0a-8c2a-bc84a2357324_WhatsApp-Image-2026-04-14-at-10.34.42-AM-2.jpeg?v=7b902286a0d22e3e60630a546d7844d0",
    full: "https://storage.readdy-site.link/project_files/5397651f-fa4a-4daf-a2cb-668ede89c5b0/b9bc670e-839b-4b0a-8c2a-bc84a2357324_WhatsApp-Image-2026-04-14-at-10.34.42-AM-2.jpeg?v=7b902286a0d22e3e60630a546d7844d0",
    span: "col-span-2 row-span-1",
  },
  {
    thumb: "https://storage.readdy-site.link/project_files/5397651f-fa4a-4daf-a2cb-668ede89c5b0/40450565-2e63-4ca0-b6a3-efd51028fafe_WhatsApp-Image-2026-04-14-at-10.34.42-AM-1.jpeg?v=117a8aeb6ead1d82414d8c62b266f63f",
    full: "https://storage.readdy-site.link/project_files/5397651f-fa4a-4daf-a2cb-668ede89c5b0/40450565-2e63-4ca0-b6a3-efd51028fafe_WhatsApp-Image-2026-04-14-at-10.34.42-AM-1.jpeg?v=117a8aeb6ead1d82414d8c62b266f63f",
    span: "col-span-1 row-span-2",
  },
  {
    thumb: "https://storage.readdy-site.link/project_files/5397651f-fa4a-4daf-a2cb-668ede89c5b0/f74e59ba-1888-4792-99ac-eeffc3a32e42_WhatsApp-Image-2026-04-14-at-10.34.42-AM.jpeg?v=6a471f667975ce2551a2177ceccdd045",
    full: "https://storage.readdy-site.link/project_files/5397651f-fa4a-4daf-a2cb-668ede89c5b0/f74e59ba-1888-4792-99ac-eeffc3a32e42_WhatsApp-Image-2026-04-14-at-10.34.42-AM.jpeg?v=6a471f667975ce2551a2177ceccdd045",
    span: "col-span-1 row-span-1",
  },
  {
    thumb: "https://storage.readdy-site.link/project_files/5397651f-fa4a-4daf-a2cb-668ede89c5b0/de0da41d-28e4-4797-82fd-8124d9c28adc_WhatsApp-Image-2026-04-14-at-10.36.43-AM.jpeg?v=b5d122a8b7a2d0936494f5bee46360cb",
    full: "https://storage.readdy-site.link/project_files/5397651f-fa4a-4daf-a2cb-668ede89c5b0/de0da41d-28e4-4797-82fd-8124d9c28adc_WhatsApp-Image-2026-04-14-at-10.36.43-AM.jpeg?v=b5d122a8b7a2d0936494f5bee46360cb",
    span: "col-span-2 row-span-2",
  },
  {
    thumb: "https://storage.readdy-site.link/project_files/5397651f-fa4a-4daf-a2cb-668ede89c5b0/27c29a25-5a82-4586-90c1-b04bfb58c935_WhatsApp-Image-2026-04-14-at-10.36.44-AM.jpeg?v=d52823ead121e9334dfdfd90f1e1831b",
    full: "https://storage.readdy-site.link/project_files/5397651f-fa4a-4daf-a2cb-668ede89c5b0/27c29a25-5a82-4586-90c1-b04bfb58c935_WhatsApp-Image-2026-04-14-at-10.36.44-AM.jpeg?v=d52823ead121e9334dfdfd90f1e1831b",
    span: "col-span-1 row-span-1",
  },
  {
    thumb: "https://storage.readdy-site.link/project_files/5397651f-fa4a-4daf-a2cb-668ede89c5b0/1781e2ad-2375-4e40-ad3e-d88cb130da78_WhatsApp-Image-2026-04-14-at-10.36.44-AM-2.jpeg?v=c04b022d4c21da38f4eadbfd42c967dc",
    full: "https://storage.readdy-site.link/project_files/5397651f-fa4a-4daf-a2cb-668ede89c5b0/1781e2ad-2375-4e40-ad3e-d88cb130da78_WhatsApp-Image-2026-04-14-at-10.36.44-AM-2.jpeg?v=c04b022d4c21da38f4eadbfd42c967dc",
    span: "col-span-1 row-span-1",
  },
  {
    thumb: "https://storage.readdy-site.link/project_files/5397651f-fa4a-4daf-a2cb-668ede89c5b0/12df20c6-a43c-46e2-90d3-767423f8c773_WhatsApp-Image-2026-04-14-at-10.36.44-AM-3.jpeg?v=359c8063ef6da4085b74ceeb6626c1f2",
    full: "https://storage.readdy-site.link/project_files/5397651f-fa4a-4daf-a2cb-668ede89c5b0/12df20c6-a43c-46e2-90d3-767423f8c773_WhatsApp-Image-2026-04-14-at-10.36.44-AM-3.jpeg?v=359c8063ef6da4085b74ceeb6626c1f2",
    span: "col-span-1 row-span-2",
  },
  {
    thumb: "https://storage.readdy-site.link/project_files/5397651f-fa4a-4daf-a2cb-668ede89c5b0/89b14a9d-ea09-4426-9336-dad9c18dfcb7_WhatsApp-Image-2026-04-14-at-10.36.44-AM-4.jpeg?v=06eab6ee5b8b97090bd517d75ff8e566",
    full: "https://storage.readdy-site.link/project_files/5397651f-fa4a-4daf-a2cb-668ede89c5b0/89b14a9d-ea09-4426-9336-dad9c18dfcb7_WhatsApp-Image-2026-04-14-at-10.36.44-AM-4.jpeg?v=06eab6ee5b8b97090bd517d75ff8e566",
    span: "col-span-2 row-span-1",
  },
  {
    thumb: "https://storage.readdy-site.link/project_files/5397651f-fa4a-4daf-a2cb-668ede89c5b0/f0945f37-84c1-472e-8b92-4adce800e44b_WhatsApp-Image-2026-04-14-at-10.37.00-AM-1.jpeg?v=c223e42911ceddc9c6add8d0f792201f",
    full: "https://storage.readdy-site.link/project_files/5397651f-fa4a-4daf-a2cb-668ede89c5b0/f0945f37-84c1-472e-8b92-4adce800e44b_WhatsApp-Image-2026-04-14-at-10.37.00-AM-1.jpeg?v=c223e42911ceddc9c6add8d0f792201f",
    span: "col-span-1 row-span-1",
  },
  {
    thumb: "https://storage.readdy-site.link/project_files/5397651f-fa4a-4daf-a2cb-668ede89c5b0/fd02ea3a-1e68-403b-b44c-65f7cc67b364_WhatsApp-Image-2026-04-14-at-10.37.51-AM-4.jpeg?v=7e0aec0e4b45c480a2b63a2dab1b22c5",
    full: "https://storage.readdy-site.link/project_files/5397651f-fa4a-4daf-a2cb-668ede89c5b0/fd02ea3a-1e68-403b-b44c-65f7cc67b364_WhatsApp-Image-2026-04-14-at-10.37.51-AM-4.jpeg?v=7e0aec0e4b45c480a2b63a2dab1b22c5",
    span: "col-span-1 row-span-1",
  },
  {
    thumb: "https://storage.readdy-site.link/project_files/5397651f-fa4a-4daf-a2cb-668ede89c5b0/65516563-3927-4002-83cd-83f1bd1137b4_WhatsApp-Image-2026-04-14-at-10.37.51-AM-5.jpeg?v=e1b33899a3c023d4aad1564c3d944761",
    full: "https://storage.readdy-site.link/project_files/5397651f-fa4a-4daf-a2cb-668ede89c5b0/65516563-3927-4002-83cd-83f1bd1137b4_WhatsApp-Image-2026-04-14-at-10.37.51-AM-5.jpeg?v=e1b33899a3c023d4aad1564c3d944761",
    span: "col-span-2 row-span-1",
  },
  {
    thumb: "https://storage.readdy-site.link/project_files/5397651f-fa4a-4daf-a2cb-668ede89c5b0/256fdebb-176b-40e2-9827-854bb98819cb_WhatsApp-Image-2026-04-14-at-10.37.51-AM-6.jpeg?v=26f73a03588e109d01e22a75cde59116",
    full: "https://storage.readdy-site.link/project_files/5397651f-fa4a-4daf-a2cb-668ede89c5b0/256fdebb-176b-40e2-9827-854bb98819cb_WhatsApp-Image-2026-04-14-at-10.37.51-AM-6.jpeg?v=26f73a03588e109d01e22a75cde59116",
    span: "col-span-1 row-span-2",
  },
  {
    thumb: "https://storage.readdy-site.link/project_files/5397651f-fa4a-4daf-a2cb-668ede89c5b0/2d8774fc-986e-46ef-aa6a-c9a40dcc18f2_WhatsApp-Image-2026-04-14-at-10.37.51-AM-7.jpeg?v=5ab9a65b0ca026cdaa8a5fcb08f42662",
    full: "https://storage.readdy-site.link/project_files/5397651f-fa4a-4daf-a2cb-668ede89c5b0/2d8774fc-986e-46ef-aa6a-c9a40dcc18f2_WhatsApp-Image-2026-04-14-at-10.37.51-AM-7.jpeg?v=5ab9a65b0ca026cdaa8a5fcb08f42662",
    span: "col-span-1 row-span-1",
  },
];

export default function Galeria() {
  const [lightboxIndex, setLightboxIndex] = useState<number | null>(null);
  const gridRef = useRef<HTMLDivElement | null>(null);
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => { if (entry.isIntersecting) setVisible(true); },
      { threshold: 0.05 }
    );
    if (gridRef.current) observer.observe(gridRef.current);
    return () => observer.disconnect();
  }, []);

  useEffect(() => {
    const handleKey = (e: KeyboardEvent) => {
      if (lightboxIndex === null) return;
      if (e.key === "Escape") setLightboxIndex(null);
      if (e.key === "ArrowRight") setLightboxIndex((prev) => prev !== null ? (prev + 1) % fotos.length : null);
      if (e.key === "ArrowLeft") setLightboxIndex((prev) => prev !== null ? (prev - 1 + fotos.length) % fotos.length : null);
    };
    window.addEventListener("keydown", handleKey);
    return () => window.removeEventListener("keydown", handleKey);
  }, [lightboxIndex]);

  useEffect(() => {
    document.body.style.overflow = lightboxIndex !== null ? "hidden" : "";
    return () => { document.body.style.overflow = ""; };
  }, [lightboxIndex]);

  const prev = () => setLightboxIndex((i) => i !== null ? (i - 1 + fotos.length) % fotos.length : null);
  const next = () => setLightboxIndex((i) => i !== null ? (i + 1) % fotos.length : null);

  return (
    <div className="min-h-screen bg-[#0f1923]">
      <Navbar />

      {/* Hero oscuro */}
      <section className="relative pt-32 pb-16 px-6 overflow-hidden">
        <div className="absolute inset-0 bg-[#0f1923]">
          <div className="absolute inset-0 opacity-10"
            style={{
              backgroundImage: "radial-gradient(circle at 20% 50%, #f97316 0%, transparent 50%), radial-gradient(circle at 80% 20%, #f97316 0%, transparent 40%)"
            }}
          />
        </div>
        <div className="relative z-10 max-w-6xl mx-auto">
          <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-6">
            <div>
              <span className="inline-flex items-center gap-2 text-orange-400 text-xs font-bold uppercase tracking-widest mb-4">
                <span className="w-8 h-px bg-orange-400 inline-block"></span>
                Charles Juárez
              </span>
              <h1 className="text-5xl md:text-7xl font-black text-white leading-none tracking-tight">
                NUESTROS<br />
                <span className="text-orange-500">TRABAJOS</span><br />
                <span className="font-black tracking-tight" style={{WebkitTextStroke: "2px #f97316", color: "transparent"}}>Y EQUIPOS</span>
              </h1>
            </div>
            <div className="md:text-right">
              <p className="text-white/50 text-sm max-w-xs md:ml-auto">
                Maestranza, transporte y arriendo de maquinarias en la Región de Coquimbo
              </p>
              <div className="mt-4 inline-flex items-center gap-2 px-4 py-2 border border-orange-500/30 rounded-full">
                <div className="w-2 h-2 bg-orange-500 rounded-full animate-pulse"></div>
                <span className="text-orange-400 text-xs font-semibold">{fotos.length} fotografías</span>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Galería tipo magazine */}
      <section className="px-6 pb-20">
        <div
          ref={gridRef}
          className={`max-w-6xl mx-auto transition-all duration-1000 ${visible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-12"}`}
        >
          {/* Grid principal */}
          <div className="grid grid-cols-2 md:grid-cols-4 auto-rows-[220px] gap-3">
            {fotos.map((foto, index) => (
              <div
                key={index}
                onClick={() => setLightboxIndex(index)}
                className={`${foto.span} relative overflow-hidden rounded-2xl cursor-pointer group`}
                style={{ animationDelay: `${index * 80}ms` }}
              >
                <img
                  src={foto.thumb}
                  alt={`Trabajo ${index + 1}`}
                  className="w-full h-full object-cover object-center transition-transform duration-700 group-hover:scale-110"
                />
                {/* Overlay con gradiente */}
                <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-400" />

                {/* Número de foto */}
                <div className="absolute top-3 left-3 opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                  <span className="text-white/70 text-xs font-mono bg-black/40 px-2 py-1 rounded-full">
                    {String(index + 1).padStart(2, "0")}
                  </span>
                </div>
              </div>
            ))}
          </div>

          {/* Línea decorativa inferior */}
          <div className="mt-12 flex items-center gap-4">
            <div className="flex-1 h-px bg-white/10"></div>
            <span className="text-white/30 text-xs uppercase tracking-widest font-semibold">Galería completa</span>
            <div className="flex-1 h-px bg-white/10"></div>
          </div>
        </div>
      </section>

      {/* Lightbox */}
      {lightboxIndex !== null && (
        <div
          className="fixed inset-0 z-50 bg-black/95 flex items-center justify-center px-4"
          onClick={() => setLightboxIndex(null)}
        >
          {/* Cerrar */}
          <button
            onClick={() => setLightboxIndex(null)}
            className="absolute top-5 right-5 w-10 h-10 flex items-center justify-center bg-white/10 hover:bg-orange-500 rounded-full text-white transition-colors cursor-pointer z-10"
          >
            <i className="ri-close-line text-xl"></i>
          </button>

          {/* Contador */}
          <div className="absolute top-5 left-1/2 -translate-x-1/2 px-5 py-1.5 bg-white/10 rounded-full text-white text-sm font-mono">
            {String(lightboxIndex + 1).padStart(2, "0")} / {String(fotos.length).padStart(2, "0")}
          </div>

          {/* Flecha izquierda */}
          <button
            onClick={(e) => { e.stopPropagation(); prev(); }}
            className="absolute left-4 md:left-8 w-12 h-12 flex items-center justify-center bg-white/10 hover:bg-orange-500 rounded-full text-white transition-colors cursor-pointer z-10"
          >
            <i className="ri-arrow-left-s-line text-2xl"></i>
          </button>

          {/* Imagen */}
          <div
            className="max-w-5xl w-full max-h-[85vh] flex items-center justify-center"
            onClick={(e) => e.stopPropagation()}
          >
            <img
              src={fotos[lightboxIndex].full}
              alt={`Trabajo ${lightboxIndex + 1}`}
              className="max-w-full max-h-[85vh] object-contain rounded-xl"
            />
          </div>

          {/* Flecha derecha */}
          <button
            onClick={(e) => { e.stopPropagation(); next(); }}
            className="absolute right-4 md:right-8 w-12 h-12 flex items-center justify-center bg-white/10 hover:bg-orange-500 rounded-full text-white transition-colors cursor-pointer z-10"
          >
            <i className="ri-arrow-right-s-line text-2xl"></i>
          </button>

          {/* Thumbnails inferiores */}
          <div className="absolute bottom-5 left-1/2 -translate-x-1/2 flex gap-2 overflow-x-auto max-w-lg px-4">
            {fotos.map((foto, i) => (
              <button
                key={i}
                onClick={(e) => { e.stopPropagation(); setLightboxIndex(i); }}
                className={`flex-shrink-0 w-12 h-12 rounded-lg overflow-hidden border-2 transition-all duration-200 cursor-pointer ${i === lightboxIndex ? "border-orange-500 scale-110" : "border-white/20 opacity-50 hover:opacity-80"}`}
              >
                <img src={foto.thumb} alt="" className="w-full h-full object-cover" />
              </button>
            ))}
          </div>
        </div>
      )}

      <Footer />
    </div>
  );
}
